import { useEffect, useState } from 'react';
import { isIosSafari, isStandaloneDisplay } from '../lib/pwa';

const STORAGE_KEY = 'brainote:ios-install-hint';

/**
 * Подсказка «Добавить на экран Домой» для iOS Safari.
 * Показывается один раз за сессию (sessionStorage), если PWA не установлена.
 */
export function IosInstallHint() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!isIosSafari() || isStandaloneDisplay()) {
      return;
    }
    try {
      if (sessionStorage.getItem(STORAGE_KEY) === '1') {
        return;
      }
    } catch {
      // sessionStorage недоступен — просто покажем один раз
    }
    setVisible(true);
    try {
      sessionStorage.setItem(STORAGE_KEY, '1');
    } catch {
      // ignore
    }
  }, []);

  if (!visible) {
    return null;
  }

  return (
    <div
      className="mx-auto mb-3 w-full max-w-3xl rounded-2xl border border-tg-accent/40 bg-tg-accent-soft px-4 py-3 text-sm text-tg-text"
      role="status"
    >
      <p className="font-medium text-tg-accent">Добавить на экран Домой</p>
      <p className="mt-1 text-tg-text-secondary">
        На iPhone: откройте меню «Поделиться» в Safari → «На экран „Домой“». Приложение будет
        работать офлайн с иконкой на домашнем экране.
      </p>
      <button
        type="button"
        className="mt-2 tg-btn-secondary"
        onClick={() => {
          setVisible(false);
        }}
      >
        Понятно
      </button>
    </div>
  );
}
